<script setup lang="ts">
const props = defineProps<{
  loading?: boolean
  disabled?: boolean
}>()
</script>

<template>
  <UiButton
    class="border border-black bg-black text-white hover:bg-transparent hover:text-black"
    :class="{
      'pointer-events-none !bg-neutral-700 !text-white': props.disabled,
    }"
  >
    <slot v-if="!props.loading" />
    <div v-else class="flex items-center justify-center">
      <Icon name="line-md:loading-twotone-loop" size="30" />
    </div>
  </UiButton>
</template>
